import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HolidayService } from '../service/holiday.service';
import { data } from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment';
import * as _ from 'underscore';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';


@Component({
  selector: 'app-add-holiday',
  templateUrl: './add-holiday.component.html',
  styleUrls: ['./add-holiday.component.css']
})
export class AddHolidayComponent implements OnInit {
  holidayForm: FormGroup;
  holidayId: any;
  status = "active";
  corporateUsers:any = [];
  preCooperates:any;
  submitted = false;
  user;
  constructor(
    private corporateService : CorporateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private holidayService: HolidayService,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {

    this.activatedRoute.params
      .subscribe((params) => {
        this.holidayId = params["id"];
       
      });


    this.holidayForm = this.fb.group({
      name: ["", Validators.required],
      startTime: ["", Validators.required],
      preStartTime: ["", Validators.required],
      endTime: ["", Validators.required],
      preEndTime: ["", Validators.required],
      status: ['active', Validators.required],
      cooperates: [[], Validators.required],
    });

    if (this.holidayId) {
      this.getHolidayById();
    }

    this.getUser();

  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.getcorporateUsers();

        }
      });
  }

  getHolidayById() {
    this.holidayService.getHolidayById(this.holidayId).subscribe((data) => {
      if (data) {
        this.holidayForm.patchValue({
          ...data,
          preStartTime : moment(data.startTime),
          startTime : data.startTime,
          preEndTime : moment(data.endTime),
          endTime : data.endTime
        })
      }
    })
  }

  onSubmit() {
    this.submitted = true;
    if(this.holidayForm.invalid){
      return
    }
    const payload = this.holidayForm.value;
    if(this.holidayId){
      console.log('holidayId', this.holidayId);
      this.holidayService.updateHoliday(this.holidayId, payload, ).subscribe((data) => {
        if (data) {
          console.log('data');
          this.router.navigateByUrl('planner/holidays')
        }
      })
    }else{
      this.holidayService.saveHoliday(payload).subscribe((data) => {
        if (data) {
          console.log('data');
          this.router.navigateByUrl('planner/holidays')
        }
      })
    }
    this.submitted = false
  }

  getcorporateUsers() {
    this.corporateService
      .getCorporateUsers(this.status)
      .subscribe(data => {
        if (data && data.length) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {})
          this.corporateUsers = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }




  setStartTime(event) {
    if (event) {
      this.holidayForm.patchValue({
        startTime: moment(event).tz(this.user.timeZone, true).startOf('day').toISOString()
      });
    }
  }
  setEndTime(event) {
    if (event) {
      this.holidayForm.patchValue({
        endTime: moment(event).tz(this.user.timeZone, true).endOf('day').toISOString()
      });
    }
  }

  selectAllFundingSource(isEnabled) {
    let selectFundingSources = [];
    if (!isEnabled) {
      for (let driver of this.corporateUsers) {
        selectFundingSources.push(driver._id);
      }
      selectFundingSources = _.uniq(selectFundingSources).sort();
    }

    this.holidayForm.patchValue({
      cooperates: selectFundingSources
    });

  }

  get form(){
    return this.holidayForm.controls;
  }


  ngOnDestroy() {

  }

}
